<template>
  <div class="row">
      <div class="col-xl-6 col-lg-12">
          <div class="main-card mb-3 card">
            <div class="card-body">
              <div class="form-row">
                  <div class="col-md-6 mb-3" :class="{'col-md-12':!talentData.tattoo}">
                    <label>Tattoo</label>
                    <div class="position-relative form-group">
                        <div>
                            <div class="custom-radio custom-control custom-control-inline">
                              <input type="radio" id="tattoo_none" class="custom-control-input" v-model="talentData.tattoo" value="">
                              <label class="custom-control-label" for="tattoo_none" @click="talentData.tattoo_visible=''"> None </label>
                            </div>
                            <div class="custom-radio custom-control custom-control-inline">
                              <input type="radio" id="tattoo_single" class="custom-control-input" v-model="talentData.tattoo" value="single">
                              <label class="custom-control-label" for="tattoo_single"> Single </label>
                            </div>
                            <div class="custom-radio custom-control custom-control-inline">
                              <input type="radio" id="tattoo_multiple" class="custom-control-input" v-model="talentData.tattoo" value="multiple">
                              <label class="custom-control-label" for="tattoo_multiple"> Multiple </label>
                            </div>
                        </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3" v-if="talentData.tattoo">
                    <label>Tattoo that are</label>
                    <div class="position-relative form-group">
                        <div>
                            <div class="custom-radio custom-control custom-control-inline">
                              <input type="radio" id="tattoo_visible" class="custom-control-input" v-model="talentData.tattoo_visible" value="visible" required>
                              <label class="custom-control-label" for="tattoo_visible"> Visible </label>
                            </div>
                            <div class="custom-radio custom-control custom-control-inline">
                              <input type="radio" id="tattoo_not_visible" class="custom-control-input" v-model="talentData.tattoo_visible" value="not_visible" required>
                              <label class="custom-control-label" for="tattoo_not_visible"> Not Visible </label>
                            </div>
                        </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3" :class="{'col-md-12':!talentData.piercings}">
                    <label>Piercings</label>
                    <div class="position-relative form-group">
                        <div>
                            <div class="custom-radio custom-control custom-control-inline">
                              <input type="radio" id="piercings_none" class="custom-control-input" v-model="talentData.piercings" value="">
                              <label class="custom-control-label" for="piercings_none" @click="talentData.piercings_visible=''"> None </label>
                            </div>
                            <div class="custom-radio custom-control custom-control-inline">
                              <input type="radio" id="piercings_single" class="custom-control-input" v-model="talentData.piercings" value="single">
                              <label class="custom-control-label" for="piercings_single"> Single </label>
                            </div>
                            <div class="custom-radio custom-control custom-control-inline">
                              <input type="radio" id="piercings_multiple" class="custom-control-input" v-model="talentData.piercings" value="multiple">
                              <label class="custom-control-label" for="piercings_multiple"> Multiple </label>
                            </div>
                        </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3" v-if="talentData.piercings">
                    <label>Piercings that are</label>
                    <div class="position-relative form-group">
                        <div>
                            <div class="custom-radio custom-control custom-control-inline">
                              <input type="radio" id="piercings_visible" class="custom-control-input" v-model="talentData.piercings_visible" value="visible" required>
                              <label class="custom-control-label" for="piercings_visible"> Visible </label>
                            </div>
                            <div class="custom-radio custom-control custom-control-inline">
                              <input type="radio" id="piercings_not_visible" class="custom-control-input" v-model="talentData.piercings_visible" value="not_visible" required>
                              <label class="custom-control-label" for="piercings_not_visible"> Not Visible </label>
                            </div>
                        </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label>Have Passport</label>
                    <div class="position-relative form-group">
                        <div>
                            <div class="custom-radio custom-control custom-control-inline">
                              <input type="radio" id="passport_yes" class="custom-control-input" v-model="talentData.passport" value="yes">
                              <label class="custom-control-label" for="passport_yes"> Yes </label>
                            </div>
                            <div class="custom-radio custom-control custom-control-inline">
                              <input type="radio" id="passport_no" class="custom-control-input" v-model="talentData.passport" value="no">
                              <label class="custom-control-label" for="passport_no"> No </label>
                            </div>
                        </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label>Willing to Travel</label>
                    <div class="position-relative form-group">
                        <div>
                            <div class="custom-radio custom-control custom-control-inline">
                              <input type="radio" id="will_travel_yes" class="custom-control-input" v-model="talentData.will_travel" value="yes">
                              <label class="custom-control-label" for="will_travel_yes"> Yes </label>
                            </div>
                            <div class="custom-radio custom-control custom-control-inline">
                              <input type="radio" id="will_travel_no" class="custom-control-input" v-model="talentData.will_travel" value="no">
                              <label class="custom-control-label" for="will_travel_no"> No </label>
                            </div>
                        </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label>Willing to cut hair</label>
                    <div class="position-relative form-group">
                        <div>
                            <div class="custom-radio custom-control custom-control-inline">
                              <input type="radio" id="will_cut_hair_yes" class="custom-control-input" v-model="talentData.will_cut_hair" value="yes">
                              <label class="custom-control-label" for="will_cut_hair_yes"> Yes </label>
                            </div>
                            <div class="custom-radio custom-control custom-control-inline">
                              <input type="radio" id="will_cut_hair_no" class="custom-control-input" v-model="talentData.will_cut_hair" value="no">
                              <label class="custom-control-label" for="will_cut_hair_no"> No </label>
                            </div>
                        </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3 containerTooltip">
                    <label>Weight</label>
                    <input type="number" class="form-control" placeholder="Weight Lbs." v-model="talentData.weight_lbs" required>
                    <p class="hovTol1">Weight Lbs.</p>
                  </div>
                  <div class="col-md-6 mb-3 containerTooltip">
                    <label>Height</label>
                    <input type="number" class="form-control" placeholder="Height Feet+Inch." v-model="talentData.height_feet" required>
                    <p class="hovTol1">Height Feet+Inch.</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label>Hat</label>
                    <select class="form-control" v-model="talentData.hat" required>
                        <option value="" disabled>Hat Size</option>
                        <option v-for="(val,key) in hat_option" :key="key" :value="val">{{val}}</option>
                    </select>
                  </div>
                  <div class="col-md-6 mb-3" v-if="talentData.gender==1">
                    <label>Jacket</label>
                    <input type="text" class="form-control" placeholder="Jacket Size" v-model="talentData.suit" required>
                  </div>
                  <div class="col-md-6 mb-3" v-if="talentData.gender==2">
                    <label>Dress</label>
                    <input type="text" class="form-control" placeholder="Dress Size" v-model="talentData.dress" required>
                  </div>
                  <div class="col-md-6 mb-3" v-if="talentData.gender==1">
                    <label>Chest</label>
                    <input type="text" class="form-control" placeholder="Chest Size" v-model="talentData.chest" required>
                  </div>
                  <div class="col-md-3 mb-3" v-if="talentData.gender==2">
                    <label>Bust</label>
                    <select class="form-control" v-model="talentData.bust" required>
                        <option value="" disabled>Bust Size</option>
                        <option v-for="(val,key) in bust_option" :key="key" :value="val">{{val}}</option>
                    </select>
                  </div>
                  <div class="col-md-3 mb-3" v-if="talentData.gender==2">
                    <label>Cup</label>
                    <select class="form-control" v-model="talentData.bust_cup" required>
                        <option value="" disabled>Cup Size</option>
                        <option v-for="(val,key) in cup_option" :key="key" :value="val">{{val}}</option>
                    </select>
                  </div>
                  <div class="col-md-6 mb-3" v-if="talentData.gender==1">
                    <label>Sleeve</label>
                    <input type="text" class="form-control" placeholder="Sleeve Size" v-model="talentData.sleeve" required>
                  </div>
                  <div class="col-md-6 mb-3" v-if="talentData.gender==2">
                    <label>Hips</label>
                    <input type="text" class="form-control" placeholder="Hips Size" v-model="talentData.hips" required>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label>Waist</label>
                    <input type="text" class="form-control" placeholder="Waist Size" v-model="talentData.waist" required>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label>Inseam</label>
                    <input type="text" class="form-control" placeholder="Inseam Size" v-model="talentData.inseam" required>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label>Shoe</label>
                    <input type="text" class="form-control" placeholder="Shoe Size" v-model="talentData.shoe" required>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label>Profession</label>
                    <textarea class="form-control" rows="4" placeholder="Profession" v-model="talentData.profession"></textarea>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label>Additional Experience</label>
                    <textarea class="form-control" rows="4" placeholder="Additional Experience" v-model="talentData.additional_experience"></textarea>
                  </div>
              </div>
            </div>
          </div>
      </div>
      <div class="col-xl-6 col-lg-12">
          <div class="main-card mb-3 card">
            <div class="card-body">
              <div class="form-row">
                  <div class="col-md-12 mb-3">
                    <label>Languages</label>
                    <br>
                    <div class="position-relative form-check form-check-inline">
                      <small class="form-check-label">
                        <input :checked="languages.length == languages_options.length"
                        type="checkbox" class="form-check-input" @click="check_all_langs"> All
                      </small>
                    </div>
                    <br>
                    <div class="position-relative form-check form-check-inline col-md-4 pr-0 mr-0" v-for="(val,key) in languages_options" :key="key">
                      <small class="form-check-label">
                        <input type="checkbox" v-model="languages" class="form-check-input" :value="val"> {{val.name}}
                      </small>
                    </div>
                  </div>
              </div>
            </div>
          </div>
      </div>
      <div class="col-md-12 mb-3 text-center">
        <button class="btn btn-warning px-4">Update</button>
      </div>
  </div>
</template>

<script>
export default {
  name: 'FormProfile2',
  props:{
    firstLoad: Object,
    talentData: Object,
  },
  data(){
    return {
      tattoo: [],
      piercings: [],
      hat_option: ["6 ¾","6 ⅞","7","7 ⅛","7 ¼","7 ⅜","7 ½","7 ⅝","7 ¾","7 ⅞","8"],
      bust_option: ["32","34","36","38","40","42"],
      cup_option: ["A","B","C","D","DD","DDD"],
      languages_options: [],
      languages: [],
    }
  },
  created(){
    this.languages_options = this.LocalStorage("segaugnal",new Array());
  },
  mounted(){
    if(!this.languages_options.length)this.get_languages();
    this.set_languages();
  },
  methods:{
    async get_languages(){
      var url = this.api+'dataOption/get_languages/'+this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
      .then((response)=>{
        console.log(response.data);
        if(response.data.error==0){
          this.languages_options = response.data.data;
          localStorage.setItem("segaugnal",JSON.stringify(response.data.data));
        }
      })
      .catch((error)=>{
        alert(error);
        console.error(error);
      })
      .then(() => {
        this.set_languages()
      })
    },
    set_languages(){
      if(!this.talentData.id || !this.languages_options.length){
        setTimeout(()=> this.set_languages() ,1000);
        return false;
      }
      this.languages = JSON.parse( this.talentData.languages ) || [];
      this.languages.forEach((e,i)=>{
        let index = this.languages_options.findIndex(x => x.id == e);
        this.languages[i] = this.languages_options[index];
      })
    },
    check_all_langs(){
      if(this.languages.length == this.languages_options.length){
        this.languages = [];
      }else{
        this.languages = this.languages_options;
      }
    },
  },
}
</script>

<style scoped>
.containerTooltip{ position: relative; }
.hovTol1{ display: none; }
.containerTooltip input:focus + .hovTol1{
  display: block;
  position: absolute;
  top: -10px;
  left: 3px;
  padding: 5px;
  border-radius: 5px;
  background: #343a40;
  color: #fff;
}
textarea{ resize: none !important; }
</style>
